import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Button } from 'foundations-components/transitional/components/Button';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { Small } from 'foundations-components/transitional/components/Small';
import FormWorkflowDependenciesTable from 'ContentComponents/components/cmv2/form/formAutomation/connectedWorkflows/FormWorkflowDependenciesTable';
import WorkflowSelect from 'ContentComponents/components/cmv2/form/formAutomation/connectedWorkflows/WorkflowSelect';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import * as formsSelectors from 'ContentData/selectors/forms';
import * as workflowsSelectors from 'ContentData/selectors/workflows';
import * as FormsActions from 'ContentData/actions/Forms';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.${key}`;
const AutomationUGP = () => {
  const {
    openUpgradeModal
  } = useUpgradeModal('forms-simple-automation');
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('freePortalUgp.label')
    }),
    children: /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('freePortalUgp.description')
      }), /*#__PURE__*/_jsxs(Button, {
        onClick: openUpgradeModal,
        size: "xs",
        use: "link",
        marginBlockStart: "100",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('freePortalUgp.upgradeButton')
        }), /*#__PURE__*/_jsx(LockBadge, {})]
      })]
    })
  });
};
function mapStateToProps(state, props) {
  const {
    formGuid,
    contentId
  } = props;
  return {
    filteredWorkflows: workflowsSelectors.getFilteredHydratedFormWorkflowDependencies(state, {
      formGuid,
      contentId
    }),
    formWorkflowDependencies: formsSelectors.getFormWorkflowDependencies(state, {
      formGuid
    }),
    form: formsSelectors.getForm(state, {
      formGuid
    }),
    allWorkflowHybridsHaveLoaded: workflowsSelectors.getAllWorkflowHybridsHaveLoaded(state, {
      formGuid
    })
  };
}
const mapDispatchToProps = {
  fetchFormWorkflowDependencies: FormsActions.fetchFormWorkflowDependencies
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class FormWorkflowDependencies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddingFirstWorkflow: false
    };
  }
  componentDidMount() {
    const {
      fetchFormWorkflowDependencies,
      form,
      formGuid,
      formWorkflowDependencies
    } = this.props;
    if (formGuid && form && !formWorkflowDependencies) {
      fetchFormWorkflowDependencies(formGuid, form.formType);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      fetchFormWorkflowDependencies,
      form,
      formGuid,
      formWorkflowDependencies
    } = this.props;
    const {
      form: prevForm,
      formGuid: prevFormGuid
    } = prevProps;
    const formHasChanged = !prevForm && form || prevFormGuid !== formGuid;
    if (formGuid && form && !formWorkflowDependencies && formHasChanged) {
      fetchFormWorkflowDependencies(formGuid, form.formType);
    }
  }
  get readOnly() {
    const {
      hasWorkflowsWriteAccess,
      readOnly
    } = this.props;
    return !hasWorkflowsWriteAccess || readOnly;
  }
  get hasNoWorkflows() {
    const {
      filteredWorkflows
    } = this.props;
    return !filteredWorkflows.length;
  }
  renderWorkflowSelect() {
    const {
      contentId,
      formGuid,
      hasWorkflowsAppAccess,
      onAddWorkflowEvent
    } = this.props;
    return !this.readOnly && contentId && /*#__PURE__*/_jsx(WorkflowSelect, {
      contentId: contentId,
      formGuid: formGuid,
      hasNoWorkflows: this.hasNoWorkflows,
      hasWorkflowsAppAccess: hasWorkflowsAppAccess,
      onAddFirstWorkflow: isAddingFirstWorkflow => this.setState({
        isAddingFirstWorkflow
      }),
      onAddWorkflowEvent: onAddWorkflowEvent
    });
  }
  renderEmptyState() {
    const {
      contentId,
      formWorkflowDependencies
    } = this.props;
    return /*#__PURE__*/_jsxs(ResultsMessage, {
      "data-selenium": "form-field-workflow-dependencies-empty-state",
      illustration: "empty-state-charts",
      illustrationProps: {
        marginBlockEnd: '200',
        width: 100
      },
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        as: "div",
        children: /*#__PURE__*/_jsx(Small, {
          children: contentId && formWorkflowDependencies && formWorkflowDependencies.length ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('emptyState.onPage')
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('emptyState.notOnPage')
          })
        })
      }), this.renderWorkflowSelect()]
    });
  }
  renderTable() {
    const {
      contentId,
      filteredWorkflows,
      formGuid,
      hasWorkflowsAppAccess,
      hasWorkflowsDeleteAccess,
      isFreePortal,
      onEditWorkflowEvent,
      onRemoveWorkflowEvent
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(FormWorkflowDependenciesTable, {
        contentId: contentId,
        formWorkflowDependencies: filteredWorkflows,
        formGuid: formGuid,
        hasWorkflowsAppAccess: hasWorkflowsAppAccess,
        hasWorkflowsDeleteAccess: hasWorkflowsDeleteAccess,
        onEditWorkflowEvent: onEditWorkflowEvent,
        onRemoveWorkflowEvent: onRemoveWorkflowEvent,
        readOnly: this.readOnly,
        seleniumKey: "form-workflow-dependencies-table"
      }), !isFreePortal && this.renderWorkflowSelect()]
    });
  }
  renderFormControl() {
    const {
      allWorkflowHybridsHaveLoaded
    } = this.props;
    let content = null;
    if (!allWorkflowHybridsHaveLoaded || this.state.isAddingFirstWorkflow) {
      content = /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered",
        paddingBlock: "300"
      });
    } else if (this.hasNoWorkflows) {
      content = this.renderEmptyState();
    } else {
      content = this.renderTable();
    }
    return /*#__PURE__*/_jsx(FormControl, {
      "data-test-id": "form-workflow-dependencies",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('combinedWorkflows.label')
      }),
      tooltip: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: i18nKey('combinedWorkflows.tooltip_jsx'),
        options: {
          href: 'https://knowledge.hubspot.com/workflows/add-contacts-to-a-workflow-with-a-form-on-a-hubspot-page'
        },
        elements: {
          Link
        }
      }),
      children: /*#__PURE__*/_jsx("div", {
        children: content
      })
    });
  }
  render() {
    const {
      allWorkflowHybridsHaveLoaded,
      isFreePortal
    } = this.props;
    if (isFreePortal) {
      return allWorkflowHybridsHaveLoaded ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(AutomationUGP, {}), !this.hasNoWorkflows && this.renderFormControl()]
      }) : /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered",
        paddingBlock: "300"
      });
    }
    return this.renderFormControl();
  }
}
FormWorkflowDependencies.defaultProps = {
  filteredWorkflows: [],
  readOnly: false
};
export default connector(FormWorkflowDependencies);